import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConstantsService } from 'src/app/shared/services/Constants/constants.service';
import { DataContextService } from 'src/app/shared/services/data-context.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuditData } from 'src/app/shared/classes/AuditTrail';
import { OutwardStatus, OutwardStatusName } from 'src/app/Enums/outwardEnum';

@Component({
  selector: 'app-supervisor-comments',
  templateUrl: './supervisor-comments.component.html',
  styleUrls: ['./supervisor-comments.component.css']
})
export class SupervisorCommentsComponent implements OnInit {

  
  private unsubscribe$ = new Subject<void>();
  
  service_URL: any;
  count : number = 0;
  reason : string = '';
  selectedRequest: any;
  flag: boolean = true;
  emailId: string ='';

  constructor(public modalRef: BsModalRef, private toast: ToastrService,private _dataContextService: DataContextService,
    ) { 
      this.service_URL = ConstantsService;
    }

  ngOnInit(): void {
    this.emailId=localStorage.getItem('email');
  }

  showcount(reason : any){
    this.count = this.reason.length;
    if(this.reason !== '' && this.count > 0){
      this.flag = false;
    }
    else{
      this.flag = true;
    }
  }

  onReject(){
    let previousStatus;
  if(this.selectedRequest.status==OutwardStatusName.Created){
    previousStatus=OutwardStatus.Created;
  }
else if(this.selectedRequest.status==OutwardStatusName.LAapprover1){
  previousStatus=OutwardStatus.LAapprover1;
}
else if(this.selectedRequest.status==OutwardStatusName.LAapprover2){
  previousStatus=OutwardStatus.LAapprover2;
}
else if(this.selectedRequest.status==OutwardStatusName.Supervisor){
  previousStatus=OutwardStatus.Supervisor;
}


    let params = {
      statusId : OutwardStatus.Declined,
      previousStatusId:previousStatus,
      requestId : this.selectedRequest.requestId,
      DeclinedByNotes:this.reason,
      Updatedby:this.emailId
    }

      let auditData = [];

      let statusChangeAudit: AuditData = new AuditData();
      statusChangeAudit.changedAttribute = "Status";
      statusChangeAudit.oldValue = this.selectedRequest.status;
      statusChangeAudit.newValue = "Declined";

      auditData.push(statusChangeAudit);

      this._dataContextService.postDatawithValues<any>(this.service_URL.OutwardDetails.UpdateStatus,params)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if(res == 1){
          this.toast.success("Request Rejected");
          
          // Saving Data in Audit Trail - only on success
          let auditParams = {
            actionPerformed : "Status Change",
            actionPerformedOn : "Outward",
            changedBy : localStorage.getItem('email'),
            dateChanged : new Date(),
            primaryKey : this.selectedRequest.serialNumber,
            generalInformation : [],
            material : [],
            statusChange: auditData
          };

          console.log('Calling audit trail API:', this.service_URL.AuditTrail.savetransactionaudittrail);
          console.log('Audit trail params:', auditParams);

          this._dataContextService.postDatawithValues<any>(this.service_URL.AuditTrail.savetransactionaudittrail, auditParams)
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(
            (auditRes) => {
              console.log('Audit trail saved successfully:', auditRes);
            },
            (auditErr) => {
              console.error('Error saving audit trail:', auditErr);
              this.toast.warning('Rejection saved but audit trail failed');
            },
            () => {
              this.modalRef.hide();
              // Delay reload to ensure audit trail completes
              setTimeout(() => {
                window.location.reload();
              }, 500);
            }
          );
        }
        else{
          this.toast.error("Something went wrong");
        }
      },
      (err) => {
        console.error('Error updating status:', err);
        this.toast.error("Something went wrong");
      })
  }

}
